import React, { useContext, Context } from 'react';

export const withContext = <P extends object, C extends object>(
  Component: React.ComponentType<P>,
  context: Context<C>,
  key: string
) => {
  interface ContextInjectorProps {
    forwardedRef: React.Ref<unknown>
  }

  const ContextInjector: React.FunctionComponent<ContextInjectorProps> = (props) => {
    const { forwardedRef, ...rest } = props;
    const newProps = {
      ...rest,
      [key]: useContext(context),
    };

    return <Component {...(newProps as P)} ref={forwardedRef} />;
  };

  return React.forwardRef((props: P, ref) => <ContextInjector {...props} forwardedRef={ref} />);
};
